import { render, staticRenderFns } from "./ServicesSection.vue?vue&type=template&id=898bf8a0&scoped=true"
import script from "./ServicesSection.vue?vue&type=script&lang=js"
export * from "./ServicesSection.vue?vue&type=script&lang=js"
import style0 from "./ServicesSection.vue?vue&type=style&index=0&id=898bf8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898bf8a0",
  null
  
)

export default component.exports